import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import { useMobile } from "../../../hooks/useMobile";

function NtPatentInfoSection(props) {
  const isMobile = useMobile();
  const duoPat = [
    {
      title: "D642,165",
    },
    {
      title: "8,243,722",
    },
    {
      title: "9,491,304",
    },
    {
      title: "9,667,800",
    },
    {
      title: "8,917,819",
    },
  ];

  const wifiPat = [
    {
      title: "D674,785",
    },
    {
      title: "8,243,722",
    },
    {
      title: "9,491,304",
    },
    {
      title: "9,667,800",
    },
    {
      title: "8,917,819",
    },
  ];

  const appPat = [
    {
      title: " 8,243,722",
    },
    {
      title: "9,491,304",
    },
    {
      title: "9,667,800",
    },
    {
      title: "9,319,746",
    },
    {
      title: "9,148,611",
    },
    {
      title: "9,521,367",
    },
    {
      title: "8,917,819",
    },
    {
      title: "9,854,003",
    },
  ];

  const renderBox = (containerStyle, renderImage, title, patents) => {
    return (
      <View
        style={[
          {
            borderRadius: 10,
            backgroundColor: "#181818",
            alignItems: "center",
            paddingBottom: 20,
          },
          isMobile ? {} : { flex: 1 },
          containerStyle,
        ]}
      >
        {renderImage}
        <NtSectionTitle style={{ fontSize: 17 }}>{title}</NtSectionTitle>
        <View style={{ flex: 1, marginTop: 35 }}>
          {patents?.map((each) => renderRow(each))}
        </View>
      </View>
    );
  };

  const renderRow = (item) => {
    return (
      <View
        key={item.title}
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 4,
        }}
      >
        <NtText style={{ color: "white", fontWeight: "300", fontSize: 14 }}>
          U.S. Pat. No.{" "}
          <NtText style={{ fontWeight: "800" }}>{item.title}</NtText>
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle style={{ textAlign: "left" }}>
        NT CONNECT's technology is covered by one or more U.S. Patents.
      </NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 10 }}>
        This web page serves to satisfy the virtual patent marking provision of
        the America Invents Act. This list is not necessarily all-inclusive, and
        NT CONNECT products and services (whether or not listed below) may be
        protected by U.S. patents other than as listed below.
      </NtSectionDescription>
      <View
        style={[
          {
            flex: 1,
            marginTop: 40,
          },
          isMobile ? { flexDirection: "column" } : { flexDirection: "row" },
        ]}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 20, marginBottom: isMobile ? 20 : 0 },
          <Image
            style={[
              {
                width: 100,
                height: 100,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/product_duo1.png")}
          />,
          "NT DUO",
          duoPat
        )}
        {renderBox(
          { marginRight: isMobile ? 0 : 20, marginBottom: isMobile ? 20 : 0 },
          <Image
            style={[
              {
                width: 100,
                height: 100,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/product_wifi.png")}
          />,
          "NT DUO WiFi",
          wifiPat
        )}
        {renderBox(
          {},
          <View
            style={{
              height: 100,
              width: 100,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NtMaterialIcon name="apps" color="white" size={40} />
          </View>,
          "NT CONNECT Apps",
          appPat
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtPatentInfoSection;
